if (!customElements.get('image-with-hotspots')) {
  class ImageWithHotspots extends HTMLElement {
    constructor() {
      super();
      this.hotspots = this.querySelectorAll('[data-image-hotspot]');
    }
  
    connectedCallback() {
      this.init()
    }
  
    init() {
      this.initListeners();
    }
  
    initListeners() {
      if (this.hotspots.length) {
        this.hotspots.forEach(hotspot=>{
          const hotspotText = hotspot.querySelector('[data-image-hotspot-text]');
          hotspot.addEventListener('mouseenter', ()=>{
            if (window.innerWidth > 768) {
              this.calculateCardPosition(hotspotText);
            }
          })
  
          hotspot.addEventListener('click', ()=>{
            this.calculateCardPosition(hotspotText);
            setTimeout(()=>{
              this.setActiveHotspot(hotspot);
            }, 100);
          })
  
          document.addEventListener('click', (event)=>{
            if(!event.target.classList.contains('.image-with-hotspots-image__hotspot-circle') && !event.target.classList.contains('.image-with-hotspots-image__hotspot')) {
              this.disableActiveHotspot();
            }
          })
        })
      }
    }
  
    setActiveHotspot(hotspot) {
      this.disableActiveHotspot();
      hotspot.classList.add('active');
    }
  
    disableActiveHotspot() {
      const activeHotspot = [...this.hotspots].find(hotspot=>hotspot.classList.contains('active'));
      if (activeHotspot) activeHotspot.classList.remove('active');
    }
  
    calculateCardPosition(card) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const containerTopBorder = this.getBoundingClientRect().top + scrollTop;
      const containerBottomBorder = this.getBoundingClientRect().top + this.getBoundingClientRect().height + scrollTop;
      const containerLeftBorder = this.getBoundingClientRect().left;
      const containerRightBorder = this.getBoundingClientRect().right;
      const containerWidth = this.getBoundingClientRect().width;
      const cardWidth = card.getBoundingClientRect().width;
      const cardHeight = card.getBoundingClientRect().height;
      const cardX = card.getBoundingClientRect().x;
      const cardY = card.getBoundingClientRect().y + scrollTop;
      const isMobile = window.innerWidth < 768;

      let topBorderError = cardY < containerTopBorder;
      let bottomBorderError = (cardY + cardHeight) > containerBottomBorder;
      let leftBorderError = cardX < containerLeftBorder;
      let rightBorderError = (cardX + cardWidth) > containerRightBorder;
      
      if (isMobile) {
        const {left, top} = this.checkPosition(card);
        left && (card.style.left = `${left}px`);
        top && (card.style.top = `${top}px`);
        card.style.transform = 'none';
      } else {
        if (topBorderError || bottomBorderError || leftBorderError || rightBorderError) {
          if (topBorderError) {
            card.style.top = '100%';
            card.style.bottom = 'auto';
          } else if (bottomBorderError) {
            card.style.top = 'auto';
            card.style.bottom = '100%';
          }
    
          if (leftBorderError && isMobile) {
            // On mobile, align to the right of the hotspot
            card.style.left = '0';
            card.style.right = 'auto';
            card.style.transform = 'none'; // Remove transform
          } else if (rightBorderError && isMobile) {
            // On mobile, align to the left of the hotspot
            card.style.left = 'auto';
            card.style.right = '0';
            card.style.transform = 'none'; // Remove transform
          } else if (leftBorderError) {
            card.style.left = '0';
            card.style.right = 'auto';
          } else if (rightBorderError) {
            card.style.left = 'auto';
            card.style.right = '0';
          }
        }
      }
      


    }

    checkPosition(card) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const containerTopBorder = this.getBoundingClientRect().top + scrollTop;
      const containerBottomBorder = this.getBoundingClientRect().top + this.getBoundingClientRect().height + scrollTop;
      const containerLeftBorder = this.getBoundingClientRect().left;
      const containerRightBorder = this.getBoundingClientRect().right;
      const cardWidth = card.getBoundingClientRect().width;
      const cardHeight = card.getBoundingClientRect().height;
      const cardX = card.getBoundingClientRect().x;
      const cardY = card.getBoundingClientRect().y;
      
      let newCardX = 0;
      let newCardY = 0;

      if (cardX <= (containerLeftBorder + 30)) {
        for (let i = 5; i < 1000; i++) {

          if ((cardX + i) > containerLeftBorder && (cardX + cardWidth) < containerRightBorder) {
            newCardX = i;
            break;
          }
        }
      }

      if (cardY < (containerTopBorder - 50)) {
        for (let i = 5; i < 1000; i++) {
          if ((newCardY + i) >= containerTopBorder && (newCardY) < containerBottomBorder) {
            newCardY = i;
            break;
          }
        }
      }

      if ((cardX + cardWidth + 50) > containerRightBorder) {
        for (let i = 5; i < 1000; i++) {
          if ((cardX + cardWidth + 100 - i) < containerRightBorder && (cardX) > containerLeftBorder) {
            newCardX = -i;
            break;
          }
        }
      }

      if (cardY + cardHeight > (containerBottomBorder + 30)) {
        for (let i = 5; i < 1000; i++) {
          if ((cardY + cardHeight - i) < containerBottomBorder) {
            newCardY = -i;
            break;
          }
        }
      }

      return {
        left: newCardX,
        top: newCardY
      }
    }
  }

	customElements.define('image-with-hotspots', ImageWithHotspots);

	document.addEventListener('shopify:section:load', (event)=>{
		if (event.target.querySelector('image-with-hotspots')) {
			event.target.querySelector('image-with-hotspots').init();
		}
	})
}